<template>
    <div v-if="chargerName">
        <v-alert border="left" class="my-0" colored-border color="primary accent-4" elevation="4">
            <h5 class="primary--text">Pagar.me</h5>
            <v-layout wrap>
                <v-flex sm6 xs12>
                    <v-btn color="grey" :small="$vuetify.breakpoint.smAndDown" class="mx-1 white--text" @click="startPayment" style="width: 100%;">
                        Iniciar um pedido
                    </v-btn>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-btn color="grey" :small="$vuetify.breakpoint.smAndDown" class="mx-1 white--text" @click="clearPayment" style="width: 100%;">
                        Limpar pedido ({{ chargerName }})
                    </v-btn>
                </v-flex>
                <v-flex xs12>
                    <v-btn color="error" x-small class="mx-1 white--text" @click="clearAllPayment" style="width: 100%;">
                        Limpar pedidos de todos carregadores
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-alert>
        <PaymentOptions :charger="configAdvanced" :chargerName="chargerName" :price="price" plug="1" />
        <ConfirmModal ref="confirm" />
    </div>
</template>

<script>
import ConfirmModal from "@/components/core/ConfirmModal";
import PaymentOptions from "@/components/shared/Payment/PaymentOptions";

export default {
    props: {
        chargerName: {
            type: String,
            required: true,
        },
        server: {
            type: String,
            required: true,
        },
        price: {
            type: String,
            required: true,
        },
        configAdvanced: {
            type: Object,
            required: true,
        },
    },

    components: { PaymentOptions, ConfirmModal },

    methods: {
        sendCommand(url, parameters) {
            if (this.server) {
                this.$http
                    .postDynamic(this.server, url, parameters)
                    .then((result) => {
                        this.$eventHub.$emit("msgSuccess", result.message ? result.message : "Enviado com sucesso.");
                    }).catch((error) => {
                        this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao enviar, tente novamente.");
                    });
            } else {
                this.$eventHub.$emit("msgError", "Falta configuração do servidor.");
            }
        },
        confirmAndSent(msg, url, parameters) {
            this.$refs.confirm.open("Confirma?", msg).then((confirm) => {
                if (confirm) this.sendCommand(url, parameters);
            });
        },
        clearAllPayment() {
            this.confirmAndSent("Deseja realmente limpar todos os pagamentos pendentes?", "api/v2/payment/command/pagarme", { charger: this.chargerName, action: "clearAll" });
        },
        clearPayment() {
            this.confirmAndSent("Deseja realmente limpar os pagamentos pendentes desse carregador?", "api/v2/payment/command/pagarme", { charger: this.chargerName, action: "clear" });
        },
        startPayment() {
            this.confirmAndSent("Deseja realmente criar um pagamento?", "api/v2/payment/command/pagarme", { charger: this.chargerName, plug: 1, action: "start" });
        },
    },
};
</script>